import React from 'react';

import { VisuallyHidden } from '@rbilabs/components-library/build/components/visually-hidden';
import { useIntl } from 'react-intl';

import { ICombo, IComboSlot, IComboSlotSelections, IModifierSelection } from '@rbi-ctg/menu';
import { ComboSlotUiPattern } from 'utils/cart';
import { getItemCalories } from 'utils/menu';

import ComboSlotDetail from './combo-slot-detail';
import SimpleWizardItem from './simple-wizard-item';
import {
  HandleComboSelection,
  HandleComboSlotSelectionQuantityUpdate,
  HandleModifierSelection,
  HandleQuantityUpdate,
} from './types';

interface ICollapsedComboSlotProps {
  comboSlot: IComboSlot;
}

const CollapsedComboSlot: React.FC<ICollapsedComboSlotProps> = ({ comboSlot }) => {
  const combinedCalories = comboSlot.options.reduce(
    (sum, item) => sum + getItemCalories(item.option) * item.minAmount,
    0
  );

  return <SimpleWizardItem title={comboSlot.name?.locale} calories={combinedCalories} />;
};

interface IComboSlotProps {
  combo: ICombo;
  comboSlot: IComboSlot;
  comboSlotSelections: IComboSlotSelections;
  excludesForPickerAspects?: { value: string }[];
  handleComboSelection: HandleComboSelection;
  handleComboSlotSelectionQuantityUpdate: HandleComboSlotSelectionQuantityUpdate;
  modifierSelections: IModifierSelection[];
  handleModifierSelection: HandleModifierSelection;
  handleModifierQuantityUpdate: HandleQuantityUpdate;
}

export const ComboSlot: React.FC<IComboSlotProps> = ({
  combo,
  comboSlot,
  comboSlotSelections,
  handleComboSelection,
  handleComboSlotSelectionQuantityUpdate,
  handleModifierQuantityUpdate,
  handleModifierSelection,
  modifierSelections,
}) => {
  const { formatMessage } = useIntl();

  if (comboSlot.uiPattern === ComboSlotUiPattern.COLLAPSED) {
    return <CollapsedComboSlot comboSlot={comboSlot} key={comboSlot._id} />;
  }

  return (
    <>
      <VisuallyHidden>
        {formatMessage(
          { id: 'visuallyHiddenSelectItem' },
          {
            itemName: comboSlot.name?.locale,
          }
        )}
      </VisuallyHidden>
      <ComboSlotDetail
        combo={combo}
        comboSlot={comboSlot}
        comboSlotSelections={comboSlotSelections}
        handleComboSelection={handleComboSelection}
        handleComboSlotSelectionQuantityUpdate={handleComboSlotSelectionQuantityUpdate}
        handleModifierSelection={handleModifierSelection}
        handleModifierQuantityUpdate={handleModifierQuantityUpdate}
        modifierSelections={modifierSelections}
      />
    </>
  );
};
